import { Box, styled, Tooltip } from "@mui/material";
import { ColumnsPanelTrigger, DataGridPro, DataGridProProps, PropsFromSlot, Toolbar, ToolbarButton } from "@mui/x-data-grid-pro";
import { useContext, useMemo } from "react";
import { AppContext } from "../../../../../../common/contexts/app_context/app_context";
import { useColumnSelectionConfig } from "../../../../../../common/hooks/use_column_selection_config";

import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import { GridSlots } from "@mui/x-data-grid";

/**
 * CustomToolbar
 */

const CustomToolbar = () => {
    return (
        <Toolbar>
            <Tooltip title="Colunas">
                <ColumnsPanelTrigger render={<ToolbarButton />}>
                    <ViewColumnIcon fontSize="small" />
                </ColumnsPanelTrigger>
            </Tooltip>
        </Toolbar>
    );
}

/**
 * CustomFooter
 */

export const CustomFooter = ({ statInformation }: PropsFromSlot<GridSlots['footer']>) => {
    return (
        <>
            {
                statInformation &&
                <div className="w-full flex flex-col justify-center items-end">
                    <div className="flex flex-row me-[166px]">
                        <p className="flex flex-row justify-center items-center w-[15rem] py-2  font-bold">
                            Valor Total Recebimento Parcial
                        </p>
                        <p className="flex flex-row justify-center items-center w-[8rem] py-2  font-bold">
                            <span className="ps-2">
                                {Number(statInformation).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                            </span>
                        </p>
                    </div>
                </div>
            }
        </>
    );
}

/**
 * StyledDataGrid
 */

interface Props extends DataGridProProps {
    tableName: string;
    height?: string;
    statInformation?: number;
}

export const RecebimentoStyledDataGrid = ({ tableName, statInformation, disableRowSelectionExcludeModel = true, height = "60vh", ...props }: Props) => {
    const [
        columnsVisibilityModel,
        handleColumnsVisibilityModel] = useColumnSelectionConfig({
            tabela: tableName,
        });

    const mode = useContext(AppContext).theme
    const StyledDataGrid = useMemo(() => {
        return styled(DataGridPro)(({ theme }) => ({
            '& .MuiDataGrid-footerContainer': {
                display: 'none',
            },
            '& .MuiDataGrid-columnHeaderTitle': {
                wordBreak: 'normal',
                whiteSpace: 'normal',
                lineHeight: 1.5,
            },
            backgroundColor: mode === "dark" ? "#2C2C2C" : "#FFFFFF",
        }))
    }, [mode]);

    return (
        <Box sx={{ height: height, width: '100%' }}>
            <StyledDataGrid
                showToolbar={true}
                slots={{
                    toolbar: CustomToolbar,
                    footer: CustomFooter,
                }}
                slotProps={{
                    columnsPanel: {
                        style: {
                            color: mode === "dark" ? '#ffffff' : "#000000",
                        }
                    },
                    footer: {
                        statInformation,
                    } as PropsFromSlot<GridSlots['footer']>,
                }}
                columnVisibilityModel={columnsVisibilityModel}
                disableColumnSorting={true}
                multipleColumnsSortingMode='always'
                disableRowSelectionExcludeModel={disableRowSelectionExcludeModel}
                onColumnVisibilityModelChange={handleColumnsVisibilityModel}
                {...props}
                disableColumnMenu={false}
                localeText={{
                    noRowsLabel: "Não existem itens para mostrar!",

                    columnsManagementSearchTitle: 'Buscar',
                    columnsManagementNoColumns: 'Não há colunas',
                    columnsManagementShowHideAllText: 'Exibir/Esconder',
                    columnsManagementReset: 'Reiniciar',
                    columnsManagementDeleteIconLabel: 'Limpar',

                    pinToLeft: 'Fixar a esquerda',
                    pinToRight: 'Fixar a direita',
                    unpin: 'Desfixar',

                    columnMenuShowColumns: 'Exibir colunas',
                    columnMenuManageColumns: 'Gerenciar colunas',

                    columnMenuHideColumn: 'Esconder coluna',
                    columnMenuUnsort: 'Desordenar',
                    columnMenuSortAsc: 'Ordenar ASC',
                    columnMenuSortDesc: 'Ordenar DESC',
                }}
            />
        </Box>
    );
}